var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasXeroAccess)?_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.openLink}},[_vm._v("\n  Open Xero Invoice\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }